import { FC } from 'react';
import { SKELETON_GRID_STYLE } from './constants';
import { SkeletonLoader } from './SkeletonLoader';
import { StyledSkeletonColumn, StyledSkeletonRow, StyledGrid } from './styled';
import { LoaderStyle, GridSkeletonType } from './types';

export const GridSkeletonLoader: FC<GridSkeletonType> = ({ rows, columns }) => (
  <StyledGrid>
    {Array.from(Array(rows).keys()).map(value => (
      <StyledSkeletonRow key={value}>
        {Array.from(Array(columns).keys()).map(v => (
          <StyledSkeletonColumn key={v}>
            <SkeletonLoader
              height={LoaderStyle.height20}
              width={LoaderStyle.width100}
              style={SKELETON_GRID_STYLE}
            />
          </StyledSkeletonColumn>
        ))}
      </StyledSkeletonRow>
    ))}
  </StyledGrid>
);
